"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./CuMeoTrendUtils";

export default function CuMeoThreeColSection({ title, items, width = "ods-50" }) {
  return (
    <div className={`cumeo-ods-detail-item ${width}`}>
      <div className="cumeo-odstb-title">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="cumeo-odstb-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="cumeo-title-odds">{item.label}</div>
            <div className={`odds ods-100 ods-white ${trendClass(item.trend)}`}>
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
